var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-template',{attrs:{"toolbar":_vm.toolbar}},[_c('i-list',{ref:"pluginsList",attrs:{"id":"pluginsViewPluginsList","items":_vm.items,"tile":_vm.pluginTile()}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }